import { ConfigurationTriggerType } from '../types/maintenances';
import { getOptionsFromObject } from '../utils/objects';

export const CONFIGURATION_TRIGGER_TYPE_LABELS = {
  [ConfigurationTriggerType.distance]: 'Distancia',
  [ConfigurationTriggerType.days]: 'Días',
};

export const CONFIGURATION_TRIGGER_TYPE_OPTIONS = getOptionsFromObject(CONFIGURATION_TRIGGER_TYPE_LABELS);
